import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-f-small', 'LetterFSmall', [["path",{"d":"M10 12h3"}],["path",{"d":"M14 8h-4v8"}]]);